import { ulid } from 'ulid';

/**
 * Generate a fresh ULID for the X-Trace-Id header on outbound requests.
 * Backend correlates these in logs (BE-101).
 */
export function generateTraceId(): string {
  return ulid();
}
